<script>
  import { Stack } from "creditdesign-svelte-components";
  import StarIcon from "../StarIcon/index.svelte";
  import TrophyIcon from "../TrophyIcon/index.svelte";

  export let companyData;

  let { description, name, profileURL, winner } = companyData;
</script>

<style>
  .raised-card:hover h3 {
    text-decoration: underline;
  }

  .icon-container {
    display: grid;
    align-items: baseline;
    column-gap: 0.4em;
    grid-template-columns: 0.8em auto;
  }

  .winner {
    margin: 0;
    font-weight: 800;
  }

  :global(.selected-icon) {
    margin-right: 0.1em;
  }
</style>

<div class="raised-card">
  <Stack stackSpace="var(--s-1)">
    <h3>
      {@html name}
    </h3>

    {#if description}
      <p>{description}</p>
    {/if}

    {#if winner}
      <div class="icon-container raised-card raised-card--no-shaddow">
        <TrophyIcon
          className="company-icon company-icon__margin-right"
          height="0.8"
          title=""
        />
        <p class="winner">Winner of the Spinoff Prize 2020</p>
      </div>
    {/if}

    {#if profileURL}
      <div class="icon-container">
        <StarIcon
          className="company-icon company-icon__margin-right"
          height="0.8"
          title=""
        />
        <a class="faux-block-link" href="{profileURL}" target="_parent">
          Read
          <i>Nature</i>
          profile
        </a>
      </div>
    {/if}
  </Stack>
</div>
